export const __ErrorLang = {
    title: 'خطایی به وجود آمده است',
    subTitle: 'لطفا کمی بعد مجددا تلاش نمایید',
    back: 'بازگشت',
    tryAgain: 'تلاش مجدد',
};
